import React from 'react';

interface MouseKeyboardSurfacesProps {}

export function MouseKeyboardSurfaces(props: Readonly<MouseKeyboardSurfacesProps>) {
	return (
		<svg width={96} height={89} viewBox="0 0 96 89" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_18835)">
				<path
					d="M81.743 52.79c.389-.488 1.812-2.646 2.263-3.394.45-.747 1.015-1.655 1.447-2.526.466-.94 1.285-2.51 1.873-3.653.502-.975 2.356-4.622-.478-7.907-1.443-1.228-2.846-1.625-5.933-2.311-4.404-.979-4.545-.491-8.78-2.125-1.998-.77-3-1.866-3.968-3.506-.337-.57.045-3.134 0-3.672-.041-.483-.527-.864-1.127-.864l-11.72-.016c-.611 0-1.124.389-1.139.88-.021.727.348 3.055 0 3.672-.52 1.361-2.213 2.706-4.646 3.507-2.418.896-3.54 1.113-7.67 2.232-1.433.389-3.467 1.023-4.57 1.842-.842.624-1.604 1.913-1.845 2.744-.24.83-.255 2.84.521 4.838.777 1.998 1.855 3.692 2.028 4.18.172.488 1.208 2.688 1.553 3.315.345.627 1.31 2.27 1.466 2.465.156.197.906 1.324 1.208 1.811.172.313.707 1.293.863 1.602.317.628 2.239 4.773 2.455 6.305.31 2.206 1.132 6.716 1.132 9.352-.36 4.189-.35 10.666-2.235 19.532-.213 1-.155 2.198 0 3.591.428 3.85 3.133 9.316 18.143 9.316 15.01 0 17.272-8.097 17.426-9.316.155-1.218.192-2.093 0-3.59-.192-1.498-2.303-14.83-2.624-19.533-.139-2.045 0-7.257.321-9.352.357-2.329 1.724-5.687 2.97-7.785.247-.416.678-1.147 1.066-1.634z"
					fill="#999"
				/>
				<mask
					id="a"
					x={1}
					y={71}
					width={34}
					height={18}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M1.992 71.37h32.645v17.273H1.992V71.37z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path d="M34.606 85.72v2.924H1.996V85.72l3.057-14.35h28.564l.989 14.35z" fill="#BEC4CB" />
				</g>
				<mask
					id="b"
					x={1}
					y={85}
					width={34}
					height={4}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M1.992 85.639h32.645V89H1.992v-3.361z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path d="M1.996 85.73h32.61V89H1.996v-3.27z" fill="#6E7B88" />
				</g>
				<mask
					id="c"
					x={38}
					y={67}
					width={67}
					height={18}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M38.719 67.29h65.289v17.273h-65.29V67.29z" fill="#fff" />
				</mask>
				<g mask="url(#c)">
					<path d="M103.946 81.64v2.923h-65.22V81.64l1.014-14.35h61.045l3.161 14.35z" fill="#BEC4CB" />
					<path
						fill="#505A63"
						stroke="#505A63"
						strokeLinecap="round"
						d="M45.73 70.85l-.35 5.12h40.489l-2.5-5.12H45.73z"
					/>
					<path transform="matrix(-1 0 0 1 86.668 76.47)" fill="#71828F" d="M0 0H41.8257V1.02014H0z" />
					<path d="M74.426 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M74.426 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path d="M74.426 72.186h1.224" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
					<path d="M78.508 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M78.508 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path d="M78.508 72.186h1.224" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
					<path d="M70.344 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M70.344 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path
						stroke="#71828F"
						strokeWidth={0.4}
						strokeLinecap="round"
						d="M70.344 72.186h1.224M65.246 70.96h10.202"
					/>
					<path d="M66.266 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M66.469 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path d="M66.469 72.186h1.224" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
					<path d="M62.184 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M62.387 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path d="M62.594 72.186h1.02" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
					<path d="M46.883 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path
						stroke="#71828F"
						strokeWidth={0.5}
						strokeLinecap="round"
						d="M47.188 73.613h1.428M47.496 72.186h1.02"
					/>
					<path d="M50.965 75.246H52.8" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path
						stroke="#71828F"
						strokeWidth={0.5}
						strokeLinecap="round"
						d="M51.371 73.613H52.8M51.676 72.186h1.02"
					/>
					<path d="M55.043 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path
						stroke="#71828F"
						strokeWidth={0.5}
						strokeLinecap="round"
						d="M55.246 73.613h1.428M55.453 72.186h1.02"
					/>
					<path d="M82.586 75.246h1.836" stroke="#71828F" strokeWidth={0.6} strokeLinecap="round" />
					<path d="M82.383 73.613h1.428" stroke="#71828F" strokeWidth={0.5} strokeLinecap="round" />
					<path d="M81.977 72.186H83.2" stroke="#71828F" strokeWidth={0.4} strokeLinecap="round" />
				</g>
				<mask
					id="d"
					x={38}
					y={81}
					width={67}
					height={8}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M38.719 81.559h65.289V89h-65.29v-7.441z" fill="#fff" />
				</mask>
				<g mask="url(#d)">
					<path d="M38.727 81.76h65.219V89h-65.22v-7.24z" fill="#6E7B88" />
				</g>
				<path
					fill="#445662"
					d="M18.316 75.45c5.1 0 5.1 4.08 5.1 4.08s0 2.04-5.1 2.04c-5.101 0-5.101-2.04-5.101-2.04s0-4.08 5.1-4.08z"
				/>
				<path
					fill="#7F7F7F"
					d="M55.236 3.328C56.336 2.686 58.934 2 60.525 2c1.59 0 4 .12 5.97 1.328 1.968 1.209 2.688 2.103 3.139 2.841.45.738 1.445 2.928 1.824 4.747.416 1.993.257 3.547.174 4.219-.212 1.722-1.15 4.66-1.95 6.075s-3.188 5.719-4.359 7.097c-1.171 1.377-2.138 1.795-4.594 1.795-2.174 0-3.574-1.255-4.534-2.288s-3.657-5.558-4.02-6.149c-.362-.59-1.896-3.566-2.138-5.546-.242-1.98-.189-3.984 0-5.203.189-1.218.983-3.308 1.927-4.747.944-1.439 2.172-2.198 3.272-2.84zM87.99 64.337c.454.372.965.65 1.504.816a3.957 3.957 0 001.638.154 3.735 3.735 0 001.523-.532 3.888 3.888 0 001.176-1.136c.48-.71.825-1.915.777-2.475a20.946 20.946 0 00-.15-1.33c-.132-.913-.311-1.405-.608-2.284-.6-1.767-.52-1.371-1.094-2.896-.488-1.932-1-3.505-1.633-7.219a48.913 48.913 0 00-1.754-7.113c-.2-.569-.393-1.103-.558-1.59l-.014-.06c-.268-.678-.508-1.309-.704-1.79a6.574 6.574 0 00-1.63-2.023 6.491 6.491 0 00-2.208-1.191 5.786 5.786 0 00-2.403-.216c-.796.099-1.567.273-2.231.792a4.639 4.639 0 00-1.177 1.539c-.225.467-1.038 1.659-1.004 4.5.01.747.178 1.537.224 1.73.046.194-.044-.178 0 0 .486 2.052 1.17 3.872 2.036 5.732.874 1.875 1.743 3.196 1.743 3.196.812 1.391 1.005 1.601 1.67 2.87.606 1.156 1.264 2.617 1.823 3.882.442 1.293 1.196 3.099 1.377 3.614.299.851.423 1.38.711 1.9.288.521.522.757.967 1.13zM32.02 65.115a4.518 4.518 0 01-1.614.678 3.812 3.812 0 01-1.654-.028 3.551 3.551 0 01-1.44-.73c-.42-.352-.762-.8-1.007-1.32-.376-.796-.544-2.093-.416-2.672.084-.377.204-.895.342-1.37.264-.937.514-1.43.937-2.312.854-1.775.716-1.372 1.51-2.896.765-1.96 1.503-3.542 2.67-7.343a54.515 54.515 0 012.778-7.22c.282-.57.551-1.106.787-1.595l.022-.06c.365-.677.695-1.307.96-1.787a7.104 7.104 0 011.917-1.923 6.606 6.606 0 012.372-.989 5.572 5.572 0 012.425.051c.778.195 1.521.465 2.107 1.083.577.66.83 1.349.95 1.74.157.514.793 1.85.348 4.811a9.983 9.983 0 01-.473 1.78c-.074.196.07-.182 0 0-.782 2.084-1.727 3.904-2.86 5.744-1.141 1.857-2.198 3.135-2.198 3.135-1.01 1.358-1.233 1.555-2.079 2.802-.77 1.137-1.638 2.585-2.378 3.84-.627 1.298-1.64 3.095-1.895 3.613-.421.853-.622 1.391-.984 1.9-.362.51-.628.73-1.126 1.068z"
				/>
				<path
					fill="#999"
					d="M12.255 78.225c.014.143.128 2.864.904 3.427 1.04.423 1.673 0 1.861-.216.293-.336 1.221-3.443 1.936-4.284.87-1.025 1.943-1.532 3.064-1.817 0 0-.33.84-.304 1.758.022.784-1.079 1.746-.434 2.285.646.539 2.07-.989 2.478-1.496.509-.633 1.081-1.46 1.311-1.868.23-.408.451-1.072.6-1.687.187-.775.364-1.956.372-2.134 0 0 .069-.429-.215-.926 0 0-.56-.673-1.076-1.049-.518-.375-1.107-.472-1.502-.489-.395-.016-1.808.36-2.44.454-.632.094-1.869.63-1.908.678 0 0-.718.311-1.7.849-.495.37-1.578.541-1.578.541-.609.113-.87.354-.87.354-.527.401-.564.83-.377 1.442.136.582-.257 1.594-.174 2.189.083.595.04 1.846.052 1.989z"
				/>
				<path
					fill="#999"
					d="M23.455 73.148c-.446-.158-.8-.385-1.22-.77-.422-.385-.63-.63-.776-.876-.174-.294-.374-.662-.408-1.063-.043-.5.407-1.363.556-1.643 1.776-3.326.967-1.47 2.11-4.299 1.126-1.849 1.491-2.405 2.163-3.145.672-.741 1.637-.808 2.127-.774.49.033 1.196.211 1.93.8.9.816 1.204 1.17 1.698 2.09.425.792.366 1.337.406 1.706.048.444-.212 1.413-.416 1.751-.677 1.048-.93 1.141-2.018 1.832-.884.531-1.231.908-2.11 1.46-.937.65-1.508 1.145-1.91 1.555-.332.338-.937 1.088-1.195 1.296-.258.209-.514.23-.937.08zM84.202 67.946c.293.321.61.563 1.084.838.473.274.92.567 1.152.706.39.231 2.377 1.503 2.724 1.48.432-.03.736-.642 1.07-1.056 1-1.237 1.558-2.16 2.016-2.921.351-.584.914-1.516 1.134-2.3.22-.785-.142-1.413-.347-1.783-.205-.37-.61-.889-1.366-1.376-1.006-.588-1.411-.776-2.357-1.04-.813-.227-1.246-.114-1.57-.099-.387.019-1.1.337-1.308.535-.63.648-.615.852-.798 1.77-.122.74-.31 1.053-.453 1.793-.204.797-.41 1.295-.605 1.652-.162.297-.568.852-.648 1.075-.08.223-.006.421.272.726z"
				/>
				<path
					fill="#999"
					d="M84.205 74.303c-1.187-.356-1.906-.679-2.628-1.667-.507-.694-.29-1.91-.362-2.731-.028-.324-.774-.336-1.08-.996-.27-.583-.49-1.402.093-1.806.703-.487 1.04-.023 1.646.08.501-.52.79-1.038 1.64-1.135.79-.089 1.246.227 1.985.544.58.25 1.409.758 2.459 1.435.933.602 1.411.848 2.224 1.597.54.498 1.019 1.166.95 1.783-.056.492-.272.74-.6 1.112-.712.807-1.367 2.039-2.663 2.211-1.551.207-2.752-.154-3.635-.419l-.029-.008z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_18835">
					<path fill="#fff" d="M0 0H96V89H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
